export default "__VITE_ASSET__BSkqD9Ph__"